<form *ngIf="form" [formGroup]="form" (ngSubmit)="onSubmit()">
  <div class="input-group mt-15">
      <mat-form-field class="input-45">
          <mat-label>UUID</mat-label>
          <input [readonly]="false" matInput type="text" formControlName="uuid">
      </mat-form-field>
      <mat-form-field class="input-45">
          <mat-label>Parametro</mat-label>
          <input [readonly]="false" matInput type="text" formControlName="parametro">
      </mat-form-field>
  </div>
  <app-input-datetime class="input-50 mt-15" name="dataOraPrelievo" [form]="form"></app-input-datetime>
  <mat-form-field class="mt-15 input-70">
      <mat-label>Tipologia punto di conformita</mat-label>
      <mat-select formControlName="tipologiaPuntoDiConformita">
          <mat-option value="PT1">(PT1) - Punto rappresentativo della rete di distribuzione interna (nel caso in cui il superamento sia dovuto al sistema di distribuzione interna in locali non prioritari)</mat-option>
          <mat-option value="PT2">(PT2) - Rubinetto di rete di distribuzione interna</mat-option>
          <mat-option value="PT3">(PT3) - Punto di riempimento per bottiglie o contenitori</mat-option>
          <mat-option value="PT4">(PT4) - Punto di utilizzo in un'azienda alimentare</mat-option>
          <mat-option value="PT5">(PT5) - Punto di erogazione di una cisterna</mat-option>
          <mat-option value="PTA">(PTA) - Punto non classificato come 'F', ma che copre i controlli su tutta la rete idropotabile.</mat-option>
      </mat-select>
  </mat-form-field>
  <p><mat-checkbox formControlName="superamento" (change)="setSupNonSign()">Superamento</mat-checkbox></p>
  <p><mat-checkbox formControlName="superamentoNonSignificativo">Superamento Non Significativo</mat-checkbox></p>
  <div *ngIf="form.value.superamento" class="mt-15">
      <mat-form-field class="input-50">
          <mat-label>Superamento Non Significativo Giustificazione</mat-label>
          <textarea matInput formControlName="superamentoNonSignificativoGiustificazione"></textarea>
      </mat-form-field>
      <app-input-number class="input-50 mt-15" (click)="notSUbmit($event)" name="superamentoPopolazioneInteressata" [form]="form" [label]="'Superamento Popolazione Interessata'"></app-input-number>
      <div class="input-group mt-15">
          <mat-form-field class="input-45">
              <mat-label>Data inizio superamento</mat-label>
              <input matInput [matDatepicker]="picker" formControlName="superamentoDataInizio">
              <mat-hint>MM/DD/YYYY</mat-hint>
              <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
          <mat-form-field class="input-45">
              <mat-label>Data fine superamento</mat-label>
              <input matInput [matDatepicker]="picker1" formControlName="superamentoDataFine">
              <mat-hint>MM/DD/YYYY</mat-hint>
              <mat-datepicker-toggle matIconSuffix [for]="picker1"></mat-datepicker-toggle>
              <mat-datepicker #picker1></mat-datepicker>
          </mat-form-field>
      </div>
      
      <mat-form-field class="input-70 mt-15">
          <mat-label>Causa superamento</mat-label>
          <mat-select formControlName="superamentoCausa">
              <mat-option *ngFor="let causa of supCause" [value]="causa.codice">{{ causa.descrizione }}</mat-option>
          </mat-select>
      </mat-form-field>
      <div class="input-group mt-15">
          <mat-form-field class="input-45">
              <mat-label>Data inizio Superamento Azione Correttiva</mat-label>
              <input formControlName="superamentoAzioneCorrettivaDataInizio" matInput [matDatepicker]="picker2">
              <mat-hint>MM/DD/YYYY</mat-hint>
              <mat-datepicker-toggle matIconSuffix [for]="picker2"></mat-datepicker-toggle>
              <mat-datepicker #picker2></mat-datepicker>
          </mat-form-field>
          <mat-form-field class="input-45">
              <mat-label>Data fine Superamento Azione Correttiva</mat-label>
              <input formControlName="superamentoAzioneCorrettivaDataFine" matInput [matDatepicker]="picker3">
              <mat-hint>MM/DD/YYYY</mat-hint>
              <mat-datepicker-toggle matIconSuffix [for]="picker3"></mat-datepicker-toggle>
              <mat-datepicker #picker3></mat-datepicker>
          </mat-form-field>
      </div>
      <h4 class="mt-15" style="margin-bottom: 0;">Superamento Azione Correttiva:</h4>
      <div class="azioni">
          <p *ngFor="let azione of azioni" class="azione">
              <mat-checkbox [disabled]="form.value.superamentoNonSignificativo" (change)="addAzioniFormArray($event, azione.codice)">
                  ({{ azione.codice }}) - {{ azione.descrizione }}
              </mat-checkbox>
          </p>
      </div>
  </div>
<!--   <button mat-raised-button type="submit" style="margin-top: 25px;" [disabled]="!form.valid">Salva</button> -->
</form>